import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/banner.jpg';
import _imports_1 from '../../../assets/music_tt.png';
import _imports_2 from '../../../assets/company-tt.png';
const _withScopeId = n => (_pushScopeId("data-v-65f406c5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "home-list"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "tt",
  alt: ""
}, null, -1));
const _hoisted_5 = {
  class: "home-list-main"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-65f406c5><div class=\"company\" data-v-65f406c5><div class=\"box\" data-v-65f406c5><img src=\"" + _imports_2 + "\" alt=\"\" data-v-65f406c5><div class=\"content\" data-v-65f406c5> 公司经营范围：许可项目:食品销售:第一类增值电信业务;第二类增值电信业务(依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准)一般项目:组织文化艺术交流活动;会议及展览服务;文化娱乐经纪人服务;文艺创作;市场调查(不含涉外调查):票务代理服务:市场营销策划;广告制作;广告发布;广告设计、代理;企业管理咨询;信息咨询服务(不含许可类信息咨询服务)，信息技术咨询服务;社会经济咨询服务;咨询策划服务;专业设计服务;平面设计;软件开发;人工智能应用软件开发;人工智能基础软件开发;数据处理和存储支持服务;信息系统集成服务;计算机软硬件及辅助设备批发:电子产品销售;食品销售(仅销售预包装食品);食品互联网销售(仅销售预包装食品)(除依法须经批准的项目外，凭营业执照依法自主开展经营活动) </div></div></div></div>", 1);
const _hoisted_7 = {
  class: "songBox"
};
const _hoisted_8 = ["autoplay", "src"];
import api from "@/api";
import PayList from "@/components/play-list/index.vue";
import router from "@/router";
import { reactive, ref, onMounted } from 'vue';
import { showConfirmDialog } from "vant";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const audio = new Audio();
    const currentId = ref(-1);
    const data = reactive({
      list: [],
      list1: [],
      status: false,
      userId: '',
      showList: true,
      songList: null,
      showRight: false,
      musicUrl: '',
      autoplay: false,
      itemPlay: null,
      imgs: [{
        id: 0,
        normal: require('../../../assets/b0.png')
      }, {
        id: 1,
        normal: require('../../../assets/b-1.png')
      }, {
        id: 2,
        normal: require('../../../assets/b-2.png')
      }]
    });
    onMounted(() => {
      var _JSON$parse;
      getlist();
      const User = window.localStorage.getItem('user');
      data.userId = (_JSON$parse = JSON.parse(User)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.id;
    });
    const getlist = async () => {
      let resulte = await api.getlist();
      let res = resulte.data.data;
      isPlay(res);
      data.list1 = res.splice(15);
      data.list = res;
    };
    const clikeme = async id => {
      switch (id) {
        case 0:
          data.imgs = [{
            id: 0,
            normal: require('../../../assets/b0.png')
          }, {
            id: 1,
            normal: require('../../../assets/b-1.png')
          }, {
            id: 2,
            normal: require('../../../assets/b-2.png')
          }];
          break;
        case 1:
          data.imgs = [{
            id: 0,
            normal: require('../../../assets/b-0.png')
          }, {
            id: 1,
            normal: require('../../../assets/b1.png')
          }, {
            id: 2,
            normal: require('../../../assets/b-2.png')
          }];
          break;
        case 2:
          data.imgs = [{
            id: 0,
            normal: require('../../../assets/b-0.png')
          }, {
            id: 1,
            normal: require('../../../assets/b-1.png')
          }, {
            id: 2,
            normal: require('../../../assets/b2.png')
          }];
          break;
        default:
          break;
      }
    };
    audio.addEventListener("timeupdate", () => {
      let currentTime = audio.currentTime;
      if (currentTime >= 10) {
        if (!data.status) {
          audio.pause();
          pause();
          showConfirmDialog({
            title: '提示',
            message: '余额不足,请充值'
          }).then(() => {
            // on confirm
            router.push({
              path: '/recharge'
            });
          }).catch(() => {
            // on cancel
            data.showRight = false;
          });
        }
      }
    });
    const byPlay = async (userId, id) => {
      let status = await api.play(userId, id);
      data.status = status.data.code == '0';
    };
    const isPlay = res => {
      res.map(item => {
        item.isPlay = false;
        return item;
      });
    };
    const play = async item => {
      data.itemPlay = item;
      data.musicUrl = item.songUrl;
      data.songList = item.songGc;
      /* if(!window.localStorage.getItem('user')){
          await byPlay(item.id)
      }else{
          await byPlay(item.id)
      } */
      window.localStorage.getItem('user') ? await byPlay(data.userId, item.id) : await byPlay('1', item.id);
      if (currentId.value != item.id) {
        data.showRight = true;
        data.autoplay = true;
        audio.src = item.songUrl;
        plays(item);
      } else {
        if (audio.paused) {
          audio.play();
          plays(item);
        } else {
          audio.pause();
          pause();
        }
      }
    };
    const pause = () => {
      isPlay(data.list);
      isPlay(data.list1);
      audio.pause();
    };
    const plays = item => {
      audio.play().then(res => {
        currentId.value = item.id;
        item.isPlay = true;
      });
    };
    return (_ctx, _cache) => {
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(PayList, {
        onPlay: play,
        class: "list1",
        list: data.list,
        src: require('../../../assets/music1.png')
      }, null, 8, ["list", "src"]), _createVNode(PayList, {
        class: "list2",
        onPlay: play,
        list: data.list1,
        src: require('../../../assets/music2.png')
      }, null, 8, ["list", "src"])])]), _hoisted_6, data.songList ? (_openBlock(), _createBlock(_component_van_popup, {
        key: 0,
        show: data.showRight,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => data.showRight = $event),
        position: "right",
        round: "",
        closeable: "",
        style: {
          width: '25%',
          height: '70%'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString(data.songList), 1), _createElementVNode("audio", {
          style: {
            "width": "100%",
            "margin": "20px auto 0"
          },
          autoplay: data.autoplay,
          onPlay: _cache[0] || (_cache[0] = $event => plays(data.itemPlay)),
          onPause: pause,
          controls: "true",
          src: data.musicUrl
        }, null, 40, _hoisted_8)])]),
        _: 1
      }, 8, ["show"])) : _createCommentVNode("", true)]);
    };
  }
});